<template>
  <div class="shell">
    <button v-if="mobile" class="nav-backdrop" aria-label="Close navigation" @click="mobile=false"></button>
    <aside :class="{show:mobile}">
      <div class="brand"><img :src="logo" alt="SLOTS"></div>
      <div class="client-workspace"><span class="workspace-avatar">IN</span><span><b>{{ companyName || 'Inventory workspace' }}</b><small>{{ platformAdmin ? 'SLOTS administration' : 'Inventory' }}</small></span><em>Active</em></div>
      <nav aria-label="Inventory navigation" class="grouped-nav">
        <section v-for="group in groups" :key="group.label" class="nav-group" :aria-label="group.label">
          <h2 class="nav-label">{{group.label}}</h2>
          <button v-for="entry in group.items" :key="entry" :class="{active:page===entry}" :aria-current="page===entry?'page':undefined" @click="go(entry)">
            <span class="nav-icon" aria-hidden="true">›</span>{{entry}}<i v-if="entry==='Material requests' && pending">{{pending}}</i>
          </button>
        </section>
      </nav>
      <div class="management"><div class="nav-label">MANAGEMENT</div><div class="system"><span>▦ &nbsp; Inventory</span><span class="tiny">Active</span></div><div class="muted-system">HRMS <small>Connect later</small></div><div class="muted-system">CRM <small>Connect later</small></div></div>
      <div class="profile"><span class="avatar">{{initials}}</span><div><b>{{username}}</b><small>{{platformAdmin?'SLOTS super administrator':roleLabel}}</small><button class="text-button" @click="$emit('sign-out')">Sign out</button></div></div>
    </aside>
    <div class="main">
      <header><div><button class="mobile" aria-label="Toggle navigation" :aria-expanded="mobile" @click="mobile=!mobile">☰</button><span class="breadcrumb">Inventory <span>/</span> <b>{{page}}</b></span></div><div class="header-right"><span class="avatar small">{{initials}}</span></div></header>
      <main><slot/></main>
    </div>
  </div>
</template>
<script>
import logo from './prototype/slots-logo-header.png';
export default {
  props:{page:String,username:String,companyName:String,role:String,platformAdmin:Boolean,pending:Number},
  data:()=>({mobile:false,logo}),
  computed:{
    initials(){return (this.username||'IN').slice(0,2).toUpperCase();},
    roleLabel(){return {manager:'Inventory manager',storekeeper:'Storekeeper',viewer:'Viewer'}[this.role]||'Inventory workspace';},
    groups(){return this.platformAdmin ? [{label:'SLOTS administration',items:['Subscribing businesses']}] : [
      {label:'Stock & production',items:['Items & stock','Material requests','Conversions','Stock transfers']},
      {label:'Purchasing',items:['Suppliers','Purchase orders','Goods receipts']},
      {label:'Administration',items:['Item catalogue','Locations']}
    ];}
  },
  methods:{go(entry){this.$emit('navigate',entry);this.mobile=false;}}
};
</script>
<style scoped src="./prototype/style.css"></style>
<style scoped src="./prototype/slots-design.css"></style>
<style scoped src="./prototype/hrms-match.css"></style>
<style scoped>
.shell{font-family:Inter,"Segoe UI",Arial,sans-serif;color:#101828}
.profile .text-button{display:block;margin-top:5px}
</style>
